import { Link } from 'react-router-dom';
import { Button } from '@repo/ui/components/ui/button';
import { lazy, Suspense } from 'react';

// Lazy load the English home page content
const EnglishHomeContent = lazy(() => import('../../components/home/english-home-content').catch(() => {
  // Fallback if component doesn't exist
  return { default: () => <div>English page content</div> };
}));

export default function EnglishPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <div className="flex flex-col min-h-screen bg-white">
        {/* Navigation */}
        <header className="sticky top-0 z-40 w-full border-b bg-background">
          <div className="container flex h-16 items-center space-x-4 sm:justify-between sm:space-x-0">
            <div className="flex gap-6 md:gap-10">
              <Link to="/" className="flex items-center space-x-2">
                <img src="/images/dendromap-logo.svg" alt="Dendromap" className="h-8 w-8" />
                <span className="hidden md:inline-block font-bold text-xl">Dendromap</span>
              </Link>
            </div>
            <div className="flex flex-1 items-center justify-end space-x-4">
              <nav className="hidden md:flex items-center space-x-6 text-sm font-medium">
                <a href="#features" className="text-foreground hover:text-primary transition-colors">Features</a>
                <a href="#pricing" className="text-foreground hover:text-primary transition-colors">Pricing</a>
                <a href="#testimonials" className="text-foreground hover:text-primary transition-colors">Testimonials</a>
                <a href="#contact" className="text-foreground hover:text-primary transition-colors">Contact</a>
              </nav>
              <div className="flex items-center space-x-4">
                <Link to="/auth">
                  <Button variant="ghost">Log in</Button>
                </Link>
                <Link to="/home">
                  <Button>Get Started</Button>
                </Link>
              </div>
            </div>
          </div>
        </header>
        <EnglishHomeContent />
      </div>
    </Suspense>
  );
}